import { ZervantLocale } from '../enums/zervantLocale'
import { invoiceLanguageToLocale } from './invoiceLanguageToLocale'

const betaBlockedLanguages: ZervantLocale[] = [ZervantLocale.FI_FI, ZervantLocale.SV_SE]

export const selectableInvoiceLanguages = Object.values(invoiceLanguageToLocale).filter(
  (locale) => !betaBlockedLanguages.includes(locale),
)
